/* fail-safe */try{
/* Proactive Coaching — audience filter for /book-a-speaker/.
 *
 * One grid, one card per talk (approved mockup 2026-08-02). Each card carries
 * data-tags="coaches|business"; the chips (.pcv-chip, the site's own, shared
 * with /library/) hide the cards that don't match.
 *
 * No section head (owner call 2026-08-05): the pressed chip and the cards'
 * own coloured tags already say who is showing, so a heading repeating the
 * chip was furniture between the filter and the answer. Sighted users get the
 * pressed-chip state; screen readers get the count through #pcx-status.
 *
 * The audience tags on the cards are buttons: pressing one applies that
 * audience's filter and parks the view on the filter row.
 *
 * Deep links keep working: /book-a-speaker/#parents (linked from About and the
 * business page) arrives filtered to Parents.
 */
(function () {
    var chips = document.getElementById('pcx-aud-chips');
    var grid = document.getElementById('pcx-grid');
    if (!chips || !grid) return;
    var buttons = [].slice.call(chips.querySelectorAll('.pcv-chip'));
    var cards = [].slice.call(grid.querySelectorAll('.pcx-tcard'));
    var status = document.getElementById('pcx-status');
    if (!buttons.length || !cards.length) return;

    function apply(aud) {
        var chip = null, shown = 0;
        buttons.forEach(function (b) {
            var is = b.getAttribute('data-aud') === aud;
            b.setAttribute('aria-pressed', is ? 'true' : 'false');
            if (is) chip = b;
        });
        cards.forEach(function (c) {
            var match = aud === 'all' || c.getAttribute('data-tags').split('|').indexOf(aud) > -1;
            c.hidden = !match;
            if (match) shown++;
        });
        /* Visually hidden, so the filter reads as a real change to a screen
           reader instead of the grid silently reshuffling. */
        if (status) {
            status.textContent = shown + ' presentation' + (shown === 1 ? '' : 's') +
                (aud === 'all' || !chip ? '' : ' for ' + chip.textContent.trim()) + '.';
        }
        // replaceState, not a hash assignment: the URL stays shareable without
        // the browser jumping the page out from under the click.
        try {
            history.replaceState(null, '', aud === 'all' ? location.pathname : location.pathname + '#' + aud);
        } catch (e) {}
    }

    buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { apply(btn.getAttribute('data-aud')); });
    });

    // The colour-coded tags on the cards double as filters.
    grid.addEventListener('click', function (e) {
        var tag = e.target.closest && e.target.closest('.pcx-tag');
        if (!tag) return;
        apply(tag.getAttribute('data-aud'));
        park();
    });

    function isAud(id) {
        return buttons.some(function (b) { return b.getAttribute('data-aud') === id; });
    }

    /* The browser scrolls to #id against the layout it parsed, and filtering
       then shortens the document out from under it. Re-park on the filter row,
       which carries scroll-margin-top so the nav doesn't cover it. Twice,
       because Chrome re-runs the fragment scroll as late-loading images settle
       the layout (hero photo, gym photo). */
    function park() {
        var row = document.querySelector('.pcx-filter') || chips;
        row.scrollIntoView({ block: 'start' });
    }
    function fromHash(initial) {
        var id = (location.hash || '').slice(1);
        if (!id || !isAud(id)) return;
        apply(id);
        requestAnimationFrame(park);
        if (initial && document.readyState !== 'complete') {
            window.addEventListener('load', function () { requestAnimationFrame(park); }, { once: true });
        }
    }
    fromHash(true);
    window.addEventListener('hashchange', fromHash);
})();
}catch(e){/* never halt the bundle */}
